import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import classes from 'Flow2/containers/Masterdata/Masterdata.module.scss';

import * as actions from "store/actions/index";
import * as metadata from "Flow2/containers/Masterdata/Masterdata";

import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';

import Checkbox from 'Flow2/components/UI/Checkbox/Checkbox';
import Input from 'Flow2/components/UI/Input/Input';

import RoomZip from 'Flow2/util/Room'

import { injectIntl, FormattedMessage } from 'react-intl';

class RoomSetting extends Component{
	
	formats = {
		"source": { value: "source", id: "media.quality.source", label: "Source" },
		"1080p": { value: "1080p", id: "media.quality.high", label: "High Quality" },
		"720p": { value: "720p", id: "media.quality.medium", label: "Medium Quality" },
		"576p": { value: "576p", id: "media.quality.low", label: "Low Quality" }
	};
    
    constructor(props) {
        super(props);
		
		this.state = {
			dlformats: props.room.dlformats ? props.room.dlformats.split(',') : [],
			medialang: props.room.medialang || "",
			formats: props.formats || this.formats,
			changed: false
		}
    }
    
    componentDidMount() {

    }
	
	save = () => {
		if(this.state.changed) {
			const data = { dlformats: this.state.dlformats.join(',') };
			if(this.props.room.hasOwnProperty("medialang")) {
				data["medialang"] = this.state.medialang;
			}
			this.props.updateMetadata(metadata.OBJECT_TYPE_ROOM, this.props.room.id, data);
			
			const zip = new RoomZip({ ...this.props }).createZip();
			if(zip.length) {
				this.props.makeZip(this.props.room.id, this.props.room.customid, zip);
			}

			this.setState({ changed: false });
		}
	}
	
	createOutput = () => {
		let content = [];
		content.push(<tr key={"dlformatsheader"}><th className={classes.Section}><FormattedMessage id="room.setting.downloadQualities" defaultMessage="Downloadable Qualities"/></th></tr>);
		content = content.concat(this.createDownloadFormats());
		
		if(this.props.room.hasOwnProperty("medialang") && !this.props.loading) {
			content.push(<tr key={"medialangheader"}><th className={classes.Section}><FormattedMessage id="room.setting.playoutLanguage" defaultMessage="Playout Language Preference"/></th></tr>);
			content = content.concat(this.createPlayoutLanguage());
		}
		
		return content;
	}
	
	createDownloadFormats = () => {
		if(this.props.mode === metadata.METADATA_MODE_TEXT) {
			return this.getFormatTextOutput();
		}
		return this.getFormatEditOutput();
	}
	
	getFormatEditOutput = () => {
		const output = [];
		
		for(let key in this.state.formats) {
			let format = this.state.formats[key];
			
			output.push(
				<tr key={format.value}>
					<th>
						<Checkbox
							value={format.value}
							id={format.id}
							label={format.label}
							checked={ (this.state.dlformats.indexOf(format.value) !== -1) ? "checked" : "" }
							changed={(evt) => {
								let dlformats = [ ...this.state.dlformats ];
								
								if(evt.target.checked) {
									if(this.state.dlformats.indexOf(format.value) === -1) {
										dlformats.push(format.value);
										this.setState({ dlformats: dlformats });
									}									
								} else {
									const index = this.state.dlformats.indexOf(format.value);
									if(index !== -1) {
										dlformats.splice(index, 1);
										this.setState({ dlformats: dlformats });
									}
								}
								
								this.setState({ changed: true });
							}} />
					</th>
				</tr>
			);
		}
		
		return output;
	}
	
	getFormatTextOutput = () => {
		if(!this.state.dlformats.length) {
			return [ <tr key={"dlformats"}><th>-</th></tr> ];
		}
		
		const output = [];
		
		for(let format of this.state.dlformats) {
			if(this.state.formats[format]) {
				output.push(
					<tr key={format}>
						<th>
							+ <FormattedMessage id={this.state.formats[format].id} defaultMessage={this.state.formats[format].label}/>
						</th>
					</tr>
				);				
			}
		}
		
		return output;
	}
	
	createPlayoutLanguage = () => {
		if(this.props.mode === metadata.METADATA_MODE_TEXT) {
			return (
				<tr key={"medialang"}>
					<th>
					{ this.state.medialang ? <FormattedMessage id={this.state.medialang} defaultMessage={this.state.medialang} /> : "-" }
					</th>
				</tr>
			);
		}
		
		const options = [];
		const langs = this.createLanguages();
		options.push({ value: "", id: "common.select.pleaseSelect", displayValue: "-- Please select --" });
		langs.forEach(lang => {
			options.push({ value: lang, id: lang, displayValue: lang });
		});
		
		const output = [];
		
		output.push(
			<tr key={"medialang"}>
				<th>
					<Input
						value={this.state.medialang}
						elementType="select_intl"
						elementConfig={{ options: options }}
						changed={(evt) => {
							this.setState({ medialang: evt.target.value, changed: true });
						}} />
				</th>
			</tr>
		);
		
		return output;
	}
	
	createLanguages = () => {
		const langs = [];
		
		this.props.clips.forEach(clip => {
			clip.mediafiles.forEach(mediafile => {
				let tags = mediafile.tags || [];
				if(tags && (typeof tags == "string")) {
					tags = tags.replace(new RegExp(';', 'g'), ',');
					tags = tags.split(',');
					
					tags.forEach((tag) => {
						if ((tag.length === 2) && (langs.indexOf(tag) === -1)) {
							langs.push(tag);
						}
					});
				}
			});
		});
		
		return langs;
    }

    render(){
        return this.createOutput();
    }
	
	componentWillReceiveProps(nextProps) {
		if(this.props.mode === metadata.METADATA_MODE_EDIT && nextProps.mode === metadata.METADATA_MODE_TEXT) {
			this.save();
		}
    }
}

const mapStateToProps = (state, ownProps) => {
	const clips = [];
	const id = ownProps.room.id;
	const clipList = state.clipList.clipLists[id] ? state.clipList.clipLists[id].clips : [];
	
	clipList.forEach(item => {
		let clip = state.clipList.clips[item];
		if(clip) {
			clips.push(clip);			
		}
	});
	
    return {
        appLang: state.ui.language,
		loading: state.clipList.loading,
		clips: clips,
		
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        updateMetadata: (type, id, metadata, reloads) => dispatch(actions.updateMetadata(type, id, metadata, reloads)),
		makeZip: (roomId, roomcustomid, mediafileids) => dispatch(actions.roomMakeZip(roomId, roomcustomid, mediafileids))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(RoomSetting)));


